/**
 * Uma ideia de encontro: o `date_idea.dart`.
 *
 * O `onde` é o que separa a casa que divide o mesmo sofá da que divide fuso
 * horário. São três valores e não dois: `perto` só faz sentido no mesmo lugar,
 * `longe` só faz sentido à distância, e `ambos` serve para as duas.
 */

export type OndeCabe = 'perto' | 'longe' | 'ambos';

export interface IdeiaDeEncontro {
  id: string;
  titulo: string;
  onde: OndeCabe;
}

/** `DateIdea.fromJson`, com as mesmas conversões frouxas. */
export function ideiaDeJson(mapa: Record<string, unknown>, posicao: number): IdeiaDeEncontro {
  const onde = `${mapa.onde ?? 'ambos'}`;
  return {
    id: `${mapa.id ?? `ideia_${posicao}`}`,
    titulo: `${mapa.title ?? ''}`,
    onde: onde === 'perto' || onde === 'longe' ? onde : 'ambos',
  };
}

/** O arquivo inteiro vira o banco de ideias. */
export function bancoDeIdeias(dados: unknown): IdeiaDeEncontro[] {
  if (!Array.isArray(dados)) return [];
  return dados.map((item, i) => ideiaDeJson((item ?? {}) as Record<string, unknown>, i));
}
